import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

// Components
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import CountdownTimer from "@/components/CountdownTimer";
import ServiceTimesBar from "@/components/ServiceTimesBar";
import MissionSection from "@/components/MissionSection";
import MediaHub from "@/components/MediaHub";
import BibleSearch from "@/components/BibleSearch";
import PrayerWall from "@/components/PrayerWall";
import PlanVisit from "@/components/PlanVisit";
import LeadershipSection from "@/components/LeadershipSection";
import CryptoGiving from "@/components/CryptoGiving";
import Footer from "@/components/Footer";

// Pages
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PortalPage from "@/pages/PortalPage";
import MessagesPage from "@/pages/MessagesPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        await axios.get(`${API}/health`);
      } catch (e) {
        console.error("API health check failed", e);
      }
    };
    checkHealth();
    setIsLoaded(true);
  }, []);

  return (
    <div className={`min-h-screen bg-white ${isLoaded ? 'animate-fade-in' : 'opacity-0'}`} data-testid="home-page">
      <Navigation />
      <main>
        <Hero />
        <CountdownTimer />
        <ServiceTimesBar />
        <MissionSection />
        <MediaHub />
        <BibleSearch />
        <PrayerWall />
        <PlanVisit />
        <LeadershipSection />
        <CryptoGiving />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/portal" element={<PortalPage />} />
            <Route path="/messages" element={<MessagesPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
